/* eslint-disable eqeqeq */
import React, { useContext, useState } from 'react'
import { Container, Row, Col, Table } from 'react-bootstrap';
import { TextField, Button } from '@material-ui/core';
import { FaChevronLeft } from 'react-icons/fa';
import PublishIcon from '@material-ui/icons/Publish';
import { ExcelRenderer } from 'react-excel-renderer';
import AuthContext from '../../context/auth-context'
import { isArray } from 'util'
import validate from 'validate.js'
import mPayment from './Payment.controller'
import DialogInfo from '../../Dialog/DialogInfo'
import CircularProgress from '@material-ui/core/CircularProgress';


const PaymentImport = (props) => {
    const kodeoutlet = props.match.params.kodeoutlet;
    const defaultPage = props.defaultPage * 1 || 1;
    const defaultrowsPerPage = props.defaultrowsPerPage * 1 || 5;
    const { clientID, token } = useContext(AuthContext);
    const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    const [dialogtext, setDialogtext] = useState()
    const [dialogUrl, setDialogUrl] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const goBack = () => {
        props.history.push(`/manajemenoutlet/${kodeoutlet}/payment/${defaultPage}/${defaultrowsPerPage}`)
    }
    const importHandler = (val) => {
        //console.log(val.target.files);
        var fileObj = val.target.files[0];
        // console.log( val.target.files)
        ExcelRenderer(fileObj, (err, resp) => {
            if (resp) {
                const listPayment = [];
                const [kodepayment, namapayment, isAutoFill, isCard] = resp.rows[0];
                if (kodepayment.toUpperCase() !== 'KODE PAYMENT' || namapayment.toUpperCase() !== 'NAMA PAYMENT' || isAutoFill.toUpperCase() !== 'JUMLAH PEMBAYARAN DIISI SISTEM SECARA OTOMATIS SAAT PEMBAYARAN' || isCard.toUpperCase() !== 'PEMBAYARAN MENGGUNAKAN MESIN EDC') {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Format data di exel tidak sesuai</P>`)
                    return
                }
                for (var i = 1, j = resp.rows.length; i < j; i++) {
                    console.log(resp.rows[i])
                    if (resp.rows[i].length > 0) {
                        const [kodepayment, namapayment, isAutoFill, isCard] = resp.rows[i];
                        //VALIDASI
                        const constraint = {
                            namapayment: {
                                length: {
                                    minimum: 3,
                                    message: "Nama Payment minimal terdiri dari 3 huruf"
                                },
                            }
                        }
                        const validator = validate({ namapayment }, constraint, { fullMessages: false });
                        if (validator !== undefined) {
                            const keys = Object.keys(validator);
                            var errorMessage = "";
                            for (const key of keys) {
                                errorMessage += validator[key] + "\n";
                            }
                            setOpenConfirmInfo(true)
                            setDialogtext(`<p>${errorMessage}<p/>`)
                            return
                        }
                        if (namapayment) {
                            if ((kodepayment || '').toUpperCase() !== 'KODE PAYMENT' || namapayment.toUpperCase() !== 'NAMA PAYMENT' || isAutoFill.toUpperCase() !== 'JUMLAH PEMBAYARAN DIISI SISTEM SECARA OTOMATIS SAAT PEMBAYARAN' || isCard.toUpperCase() !== 'PEMBAYARAN MENGGUNAKAN MESIN EDC') {
                                listPayment.push({ kodepayment, namapayment, isAutoFill, isCard })
                            }
                        }
                    }
                }
                setIsLoading(true);
                mPayment.importPayment(kodeoutlet, listPayment, clientID, token).then(resp => {
                    setIsLoading(false);
                    if (resp) {
                        setOpenConfirmInfo(true)
                        setDialogtext(`<p>Data Berhasil di Import<p/>`)
                        setDialogUrl(`/manajemenoutlet/${kodeoutlet}/payment/1/5`)
                    } else {
                        setOpenConfirmInfo(true)
                        setDialogtext(`<p>Data Gagal di import<p/>`)
                    }
                }).catch(err => {
                    if (isArray(err) && err.length > 0) {
                        setOpenConfirmInfo(true)
                        setDialogtext(`<p>Gagal Simpan :  ${err[0].message}<p/>`)
                    } else if (typeof err == 'error') {
                        setOpenConfirmInfo(true)
                        setDialogtext(`<p>${err.message}<p/>`)
                    } else {
                        console.log(err);
                    }
                })
            }
            else {
                console.log(err);
            }
        });
    }
    return (
        <Container>
            <Row style={{ marginTop: 20, marginBottom: 20 }}>
                <Col xs={12}>
                    <h4 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom"><FaChevronLeft onClick={goBack.bind(this)} className="btnBack" />Import Payment</h4>
                </Col>
                <Col xs={12} style={{ marginTop: 20 }}>
                    <TextField
                        id="importFile"
                        label="Gambar"
                        type="file"
                        accept=".csv"
                        style={{ display: 'none' }}
                        onChange={importHandler.bind(this)}
                    />
                    <label htmlFor="importFile">
                        <Button variant="contained" color="primary" component="span"><PublishIcon /> Pilih file</Button>
                        {isLoading && (
                            <span><CircularProgress /> Mohon tunggu sedang import data...</span>
                        )}
                    </label>
                    <p>
                        File harus dalam format XLSX (namafile.xlsx).<br />
                        Contoh format sebagai berikut :
                    </p>
                    <ul>
                        <li>Untuk contoh format, Anda bisa menggunakan <a href="/Import/ImportPayment.xlsx" download>Template ini</a></li>
                        <li>Setiap kode kategori tidak boleh sama</li>
                        <li>Kode kategori yang berawal dari angka 0(NOL) ditulis di excel dengan format tanda petik 1 didepan kode. Contoh : '0001</li>
                    </ul>
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr className="tabelWhite">
                                <th>Kode Payment</th>
                                <th>Nama Payment</th>
                                <th>Jumlah pembayaran diisi sistem secara otomatis saat pembayaran</th>
                                <th>Pembayaran menggunkan mesin EDC</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="tabelWhite">
                                <td>0001</td>
                                <td>Payment 1</td>
                                <td>TRUE</td>
                                <td>FALSE</td>
                            </tr>
                            <tr className="tabelWhite">
                                <td>0002</td>
                                <td>Payment 2</td>
                                <td>FALSE</td>
                                <td>TRUE</td>
                            </tr>
                            <tr className="tabelWhite">
                                <td>0003</td>
                                <td>Payment 3</td>
                                <td>FALSE</td>
                                <td>TRUE</td>
                            </tr>
                            <tr className="tabelWhite">
                                <td>0004</td>
                                <td>Payment 4</td>
                                <td>TRUE</td>
                                <td>FALSE</td>
                            </tr>
                            <tr className="tabelWhite">
                                <td>0005</td>
                                <td>Payment 5</td>
                                <td>FALSE</td>
                                <td>TRUE</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} url={dialogUrl} redirect={props.history.push} />
        </Container>
    )
}

export default PaymentImport;